export function startTour(tourId) {
  const isDev = window.location.href.includes('loomlocal.com');
  const isStaging = window.location.href.includes('stage.loom.com');

  if (isDev || isStaging) {
    alert(
      'Unfortunately, Intercom tours are only available in production. Tour ID:' +
        tourId
    );

    return;
  }

  if (window.Intercom) {
    window.Intercom('startTour', tourId);
  } else {
    console.log('Intercom not available');
  }
}
